import { createAction, props } from '@ngrx/store';

export const setCountryCode = createAction(
   '[Global] Set Country Code',
   props<{ countryCode: string }>()
);
